import 'lg-thumbnail/dist/lg-thumbnail';



// WEBPACK FOOTER //
// ./scripts/autoload/_lg-thumbnail.js